var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTransactions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-2,.cls-3{stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:25px;}.cls-2{fill:#f8f8f8;}.cls-3{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICON") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_2",
    "data-name": "Artboard 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.51,
    y: 250.33,
    width: 1004.99,
    height: 590.18,
    rx: 15.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 785.05,
    y1: 952.31,
    x2: 128.54,
    y2: 952.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M170.5,982.79,130,958.84c-6.17-3.64-6.17-10.51,0-14.16l40.51-24"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 328.34,
    y1: 137.76,
    x2: 984.84,
    y2: 137.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M942.88,168.24l40.51-24c6.16-3.64,6.16-10.52,0-14.16l-40.51-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.39,
    y: 361.04,
    width: 907.21,
    height: 88.75,
    rx: 15.95
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransactions);
export default __webpack_public_path__ + "static/media/ICON_Transactions.c1da0e4c68be4f3a6b53bba90fe54132.svg";
export { ForwardRef as ReactComponent };